import { WSTable } from "@wingspanhq/fe-component-library";
import { IInvoice } from "@wingspanhq/payments/dist/interfaces";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { IPayerRow } from "../../../../services/search";
import { getColumns } from "./columns";

export type TableItemData = WorkLog;

type Props = {
  workLogs: WorkLog[];
  payersMap: Map<string, IPayerRow>;
  invoicesMap?: Map<string, IInvoice>;
  onRowClick?: (workLog: WorkLog) => void;
};

export const TableWorkLogsPayeeView: React.FC<Props> = props => {
  const tableData = useMemo(() => {
    return props.workLogs.map(workLog => ({
      id: workLog.id ?? "",
      data: workLog
    }));
  }, [props.workLogs]);

  const columns = useMemo(
    () =>
      getColumns({
        payersMap: props.payersMap,
        invoicesMap: props.invoicesMap
      }),
    [props.payersMap, props.invoicesMap]
  );

  return (
    <WSTable<TableItemData>
      tableData={tableData}
      columns={columns}
      onRowClick={
        props.onRowClick ? item => props.onRowClick!(item.data) : undefined
      }
    />
  );
};
